import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { updateInvoiceSettings } from "../../../../redux/reducers/businessSlice";
import Spinner from "../../../../components/Spinner";

export default function BusinessInformation({ data: businessdata, businessId: businessId }) {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.business);
  
  const validationSchema = Yup.object({
    businessTaxId: Yup.string().required("Tax ID is required"),
    salesVolume: Yup.string().required("Sales Volume is required"),
    yearsInBusiness: Yup.string().required("Years in Business is required"),
    businessUrl: Yup.string().url("Must be a valid URL").required("Business URL is required"),
    supportEmail: Yup.string().email("Invalid email").required("Support email is required"),
    supportPhone: Yup.string().required("Support phone is required"),
    supportUrl: Yup.string().url("Must be a valid URL").required("Support URL is required"),
  });

  const formik = useFormik({
    initialValues: {
      businessTaxId: businessdata?.businessTaxId || "",
      salesVolume: businessdata?.salesVolume || "",
      yearsInBusiness: businessdata?.yearsInBusiness || "",
      businessUrl: businessdata?.businessUrl || "",
      supportEmail: businessdata?.supportEmail || "",
      supportPhone: businessdata?.supportPhone || "",
      supportUrl: businessdata?.supportUrl || "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      dispatch(updateInvoiceSettings({ id: businessId, data: values }));
    },
  });

  return (
    <Spinner active={loading}>
      <div className="display-card">
        <h3>Business Information</h3>
        <p>Enter and Update your Business Informations</p>
        <form onSubmit={formik.handleSubmit}>
          <div className="form-group row">
            <div className="col-xxl-4 col-lg-4 col-md-6 col-12 mb-3">
              <label>
                Business TAX Id <span className="required">*</span>
              </label>
              <input
                name="businessTaxId"
                value={formik.values.businessTaxId}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.businessTaxId && formik.errors.businessTaxId ? "is-invalid" : ""}`}
                placeholder="Enter Business Tax Id"
              />
              {formik.touched.businessTaxId && formik.errors.businessTaxId && (
                <div className="invalid-feedback">{formik.errors.businessTaxId}</div>
              )}
            </div>
            
            <div className="col-xxl-4 col-lg-4 col-md-6 col-12 mb-3">
              <label>
                Business Sales Volume <span className="required">*</span>
              </label>
              <select
                name="salesVolume"
                value={formik.values.salesVolume}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.salesVolume && formik.errors.salesVolume ? "is-invalid" : ""}`}
              >
                <option value="">Select Sales Volume</option>
                <option value="0-50k">0-50k</option>
                <option value="50k-100k">50k-100k</option>
                <option value="100k+">100k+</option>
              </select>
              {formik.touched.salesVolume && formik.errors.salesVolume && (
                <div className="invalid-feedback">{formik.errors.salesVolume}</div>
              )}
            </div>

            <div className="col-xxl-4 col-lg-4 col-md-6 col-12 mb-3">
              <label>
                Years In Business <span className="required">*</span>
              </label>
              <input
                name="yearsInBusiness"
                value={formik.values.yearsInBusiness}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.yearsInBusiness && formik.errors.yearsInBusiness ? "is-invalid" : ""}`}
                placeholder="Enter Years In Business"
              />
              {formik.touched.yearsInBusiness && formik.errors.yearsInBusiness && (
                <div className="invalid-feedback">{formik.errors.yearsInBusiness}</div>
              )}
            </div>
            <hr className="m-1" />
            <div className="col-xxl-4 col-lg-4 col-md-6 col-12 mb-3">
              <label>
                Business Url <span className="required">*</span>
              </label>
              <input
                name="businessUrl"
                value={formik.values.businessUrl}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.businessUrl && formik.errors.businessUrl ? "is-invalid" : ""}`}
                placeholder="Enter Business Url"
              />
              {formik.touched.businessUrl && formik.errors.businessUrl && (
                <div className="invalid-feedback">{formik.errors.businessUrl}</div>
              )}
            </div>
            <div className="col-xxl-4 col-lg-4 col-md-6 col-12 mb-3">
              <label>
                Support Email <span className="required">*</span>
              </label>
              <input
                name="supportEmail"
                value={formik.values.supportEmail}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.supportEmail && formik.errors.supportEmail ? "is-invalid" : ""}`}
                placeholder="Enter Support Email"
              />
              {formik.touched.supportEmail && formik.errors.supportEmail && (
                <div className="invalid-feedback">{formik.errors.supportEmail}</div>
              )}
            </div>
            <div className="col-xxl-4 col-lg-4 col-md-6 col-12 mb-3">
              <label>
                Support Phone <span className="required">*</span>
              </label>
              <input
                name="supportPhone"
                value={formik.values.supportPhone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.supportPhone && formik.errors.supportPhone ? "is-invalid" : ""}`}
                placeholder="Enter Support Phone"
              />
              {formik.touched.supportPhone && formik.errors.supportPhone && (
                <div className="invalid-feedback">{formik.errors.supportPhone}</div>
              )}
            </div>
            <div className="col-xxl-4 col-lg-4 col-md-6 col-12 mb-3">
              <label>
                Support Url <span className="required">*</span>
              </label>
              <input
                name="supportUrl"
                value={formik.values.supportUrl}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.supportUrl && formik.errors.supportUrl ? "is-invalid" : ""}`}
                placeholder="Enter Support Url"
              />
              {formik.touched.supportUrl && formik.errors.supportUrl && (
                <div className="invalid-feedback">{formik.errors.supportUrl}</div>
              )}
            </div>
          </div>
          <div className="form-group row justify-content-center mt-3">
            <button
              className="btn btn-primary"
              type="submit"
              disabled={loading || !formik.dirty}
              style={{ width: '200px' }}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </Spinner>
  );
}
